import profile_utilities from "../../../mixins/ProfileUtilities"

const tab = {
    mixins: [profile_utilities],
    computed: {
        project () {
            return this.record
        },
        can_edit_prospective_data () {
            if(this.is_db_admin_active) return true
            if(this.is_some_designer) {
                return this.editable && (this.im_pic_or_pm || this.my_project)
            }
            return this.editable
        },
        is_valid_projected_start_date () {
            if(!this.project.projected_starts_at || !this.start_date) return true
            const projected_starts_at = this.$moment(this.project.projected_starts_at)
            return projected_starts_at.isSameOrBefore(this.start_date)
        }
    },
    props: {
        record: {
            required: true
        },
        editable: {
            type: Boolean,
            default: true
        },
        wizardShown: {
            default: false
        }
    }
}

export default tab
